




import { defineComponent, PropType } from '@nuxtjs/composition-api';

type Tag = 'primary' | 'secondary';

export default defineComponent({
  name: 'TabElement',
  props: {
    variant: {
      type: String as PropType<Tag>,
      default: 'primary',
    },
    text: {
      type: String,
      default: '',
    },
  },
});
